import { useNavigate } from 'react-router-dom';

/** @type {import('react-router-dom').NavigateFunction} */
let navigate = (_to, _options) => assert(false, 'Attempted history nav before init!');

export function NavigateSetter({ children }) {
  navigate = useNavigate();

  return children;
}

export default NavigateSetter;

export { navigate };
